import { jsx as _jsx } from "react/jsx-runtime";
import { Stepper } from "@opala-ds/react";
import { useIsMobile } from "../../hooks/useIsMobile";
import EducationalInstitutionDataForm from "../Forms/EducationalInstitutionDataForm";
import AddressDataForm from "../Forms/AddressDataForm";
import RepresentativeOfInstitutionForm from "../Forms/RepresentativeOfInstitutionForm";
import ModalitiesRegisteredForm from "../Forms/ModalitiesRegisteredForm";
import TermsAndConditionsIndividualSchoolForm from "../Forms/TermsAndConditionsIndividualSchoolForm";
import useIndividualStore from "../../stores/individualStore";
import { useCreateIndividualModality } from "../../queries/jepis";
export default function IndividualStepper() {
    var educationalInstitutionData = useIndividualStore(function (state) { return state.educationalInstitutionData; });
    var addressData = useIndividualStore(function (state) { return state.addressData; });
    var representativeOfInstitutionData = useIndividualStore(function (state) { return state.representativeOfInstitutionData; });
    var modalitiesRegisteredData = useIndividualStore(function (state) { return state.modalitiesRegisteredData; });
    var email = useIndividualStore(function (state) { return state.email; });
    var setEducationalInstitutionData = useIndividualStore(function (state) { return state.setEducationalInstitutionData; });
    var setAddressData = useIndividualStore(function (state) { return state.setAddressData; });
    var setRepresentativeOfInstitutionData = useIndividualStore(function (state) { return state.setRepresentativeOfInstitutionData; });
    var setModalitiesRegisteredData = useIndividualStore(function (state) { return state.setModalitiesRegisteredData; });
    var setEmail = useIndividualStore(function (state) { return state.setEmail; });
    var isMobile = useIsMobile();
    var createIndividualSchool = useCreateIndividualModality().mutate;
    return (_jsx(Stepper, { showIndicator: !isMobile, initialStep: 0, orientation: "horizontal", steps: [
            {
                content: (_jsx(EducationalInstitutionDataForm, { defaultValues: educationalInstitutionData, onSubmit: setEducationalInstitutionData })),
                title: "Instituição de Ensino",
            },
            {
                content: (_jsx(AddressDataForm, { defaultValues: addressData, onSubmit: setAddressData })),
                title: "Endereço da Instituição de Ensino",
            },
            {
                content: (_jsx(RepresentativeOfInstitutionForm, { defaultValues: representativeOfInstitutionData, onSubmit: function (data) {
                        setRepresentativeOfInstitutionData(data);
                        setEmail(data.email);
                    } })),
                title: "Representante da instituição",
            },
            {
                content: (_jsx(ModalitiesRegisteredForm, { defaultValues: modalitiesRegisteredData, onSubmit: setModalitiesRegisteredData })),
                title: "Modalidades Inscritas",
            },
            {
                content: (_jsx(TermsAndConditionsIndividualSchoolForm, { onSubmit: function (data) {
                        createIndividualSchool({
                            payload: {
                                email: email,
                                educationalInstitutionData: educationalInstitutionData,
                                addressData: addressData,
                                representativeOfInstitutionData: representativeOfInstitutionData,
                                modalitiesRegisteredData: modalitiesRegisteredData,
                            },
                        });
                    } })),
                title: "Aceite dos Termos e Condições",
            },
        ], textAlignment: "center" }));
}
